export default __webpack_public_path__ + "static/media/4-Strings-Chord-Diagram-v2.1722a411.png";